import mediaUrl from "../utils/mediaUrl";
import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";

import "../assets/css/dashboard.css";
import auth from "../utils/auth";
import axios from "axios";
import { IonPage } from "@ionic/react";

const Dashboard = (props) => {
	const [isOpaque, setIsOpaque] = useState(true);
	const [incompleteCourses, setIncompleteCourses] = useState([]);
	const [completedCourses, setCompletedCourses] = useState([]);
	const [suggestedCourses, setSuggestedCourses] = useState([]);

	useEffect(() => {
		window.addEventListener("scroll", (e) => {
			if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
				setIsOpaque(false);
			} else {
				setIsOpaque(true);
			}
		});

		const config = {
			headers: {
				"Content-Type": "application/json",
				"x-auth-token": auth.getToken(),
			},
		};

		axios
			.get("/progress/userCourses", config)
			.then((res) => {
				console.log(res.data);
				setIncompleteCourses(res.data.incomplete);
				setCompletedCourses(res.data.completed);

				const enrolledIds = [
					...res.data.incomplete,
					...res.data.completed,
				].map((c) => String(c._id));

				return axios.get("/courses").then((coursesRes) => {
					const suggestions = (coursesRes.data.courses || [])
						.filter(
							(c) =>
								c.status !== "draft" &&
								!enrolledIds.includes(String(c._id))
						)
						.sort((a, b) =>
							a.status === "comingSoon" === (b.status === "comingSoon")
								? 0
								: a.status === "comingSoon"
								? 1
								: -1
						)
						.slice(0, 3);
					setSuggestedCourses(suggestions);
				});
			})
			.catch((err) => console.log(err));

		return () => {
			window.removeEventListener("scroll", (e) => {
				if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
					setIsOpaque(false);
				} else {
					setIsOpaque(true);
				}
			});
		};
	}, []);

	return (
		<IonPage>
			<div id="header_place">
				<Header isOpaque={isOpaque} isDashboard={true} />
			</div>

			<div className="dashboard_area">
				<div className="center_wrapper">
					<div className="intro_box">
						<h2 className="greeting">
							Hello <span>{auth.getUserInfo().fullName}</span>!
						</h2>
						<h3>
							{incompleteCourses.length == 0 && completedCourses.length != 0
								? "You're all caught up! Your completed courses:"
								: incompleteCourses.length == 0 && completedCourses.length == 0
								? "No courses Opted"
								: "Continue from where you left!"}
						</h3>
					</div>

					<div className="courses_cards">
						{incompleteCourses.length > 0 &&
							incompleteCourses.map((c, key) => {
								return (
									<div key={key} className="course">
										<img
											className="course_image"
											src={mediaUrl(c.thumbnail)}
											alt=""
										/>
										<div className="course_title">{c.name}</div>
										{c.description && (
											<div className="course_description">
												{c.description}
											</div>
										)}
										<div className="course_attributes">
											<div className="time">
												<svg
													className="time_icon"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													aria-hidden="true"
												>
													<circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
													<path d="M12 7.5V12l3 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
												</svg>
												15 Min.
											</div>
										</div>
										<a href={`/courses/${c._id}/view`} className="know_more">
											Continue
										</a>
									</div>
								);
							})}
					</div>
					{completedCourses.length > 0 && incompleteCourses.length > 0 && (
						<h3 className="dash-section-label">Your completed courses</h3>
					)}
					<div className="courses_cards">
						{completedCourses.length > 0 &&
							completedCourses.map((c, key) => {
								return (
									<div key={key} className="course">
										<img
											className="course_image"
											src={mediaUrl(c.thumbnail)}
											alt=""
										/>
										<div className="course_title">{c.name}</div>
										{c.description && (
											<div className="course_description">
												{c.description}
											</div>
										)}
										<div className="course_attributes">
											<div className="time">
												<svg
													className="time_icon"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
													aria-hidden="true"
												>
													<circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
													<path d="M12 7.5V12l3 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
												</svg>
												15 Min.
											</div>
										</div>
										<a href={`/courses/${c._id}/view`} className="know_more">
											View Course
										</a>
									</div>
								);
							})}
					</div>
				</div>
			</div>

			{suggestedCourses.length > 0 && (
			<section id="our_courses">
				<div className="center_wrapper">
					<h2 className="more-courses dash-more">You may also like</h2>
					<div className="courses_cards">
						{suggestedCourses.map((c, key) => (
							<div key={key} className="course">
								<img
									className="course_image"
									src={mediaUrl(c.thumbnail)}
									alt=""
								/>
								<div className="course_title">{c.name}</div>
								{c.description && (
									<div className="course_description">{c.description}</div>
								)}
								<div className="course_attributes">
									<div className="time">
										<svg
											className="time_icon"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											aria-hidden="true"
										>
											<circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth="1.6" />
											<path d="M12 7.5V12l3 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
										</svg>
										{c.duration || "15 mins"}
									</div>
									<div className="inr">INR {c.price || 500}/-</div>
								</div>
								{c.status === "comingSoon" ? (
									<button className="know_more coming_soon" disabled>
										Coming Soon
									</button>
								) : (
									<a href={`/courses/${c._id}`} className="know_more">
										Know More
									</a>
								)}
							</div>
						))}
					</div>
				</div>
			</section>
			)}

			<div id="footer_place">
				<Footer />
			</div>
		</IonPage>
	);
};

export default Dashboard;
